<template v-if="link">
		<li class="flex justify-between w-80 hover:text-gray-300 hover:cursor-pointer" @click="copy">
          <div>
            <span class="inline-block leading-none align-middle">
                {{ link }}
            </span>
          </div>
          <div class="">
            <span class="tool-tip mr-2 text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline border-2 border-blue-500 text-white rounded-full bg-blue-500" :class="{ active: showTooltip }">Kopieret</span>
            <ClipboardCopyIcon class="h-5 inline pr-2" />
          </div>
        </li>
</template>
<script>
  import { ClipboardCopyIcon } from '@heroicons/vue/outline'
  export default {
      components: {
          ClipboardCopyIcon,
      },
      props: {
          link: null,
      },
      data() {
          return {
              showTooltip: false
          }
      },

      methods: {
          copy() {
              this.showTooltip = true
              navigator.clipboard.writeText("&collection="+this.link)
              setTimeout(() => {
                  this.showTooltip = false
              }, 600)
          },
      },
  }
</script>
<style scoped>
.tool-tip.active {
    @apply opacity-100;
}

.tool-tip {
    @apply opacity-0;
    transition: opacity 0.4s;
}
</style>
